<template>
	<div class="playbooks-recommendations">
		<template v-for="card in cards">
			<playbooks-recommendation v-if="isRecommendation(card.cardType)" :key="card.id" :recommendation="card" />
			<playbooks-upsell v-else :key="card.slug" :upsell="card" class="container" />
		</template>
	</div>
</template>

<script>
import { mapState, mapGetters } from 'vuex';

export default {
	computed: {
		...mapState('playbooks', ['recommendations', 'dismissedRecommendations']),
		...mapGetters('playbooks', ['availableUpsells']),
		/**
		 * Generate the array of cards to show.
		 *
		 * We need to filter out dismissed recommendations and inject upsells between recommendations.
		 *
		 * @returns {Array} The array of cards to show.
		 */
		cards() {
			let cards = [];
			let upsellsAdded = 0;

			const availableUpsells = this.availableUpsells;
			const upsellCount = availableUpsells.length;

			this.recommendations.forEach((r) => {
				if (this.dismissedRecommendations.includes(r.slug)) {
					return;
				}

				// Add Recommendation
				cards.push(r);

				if (upsellsAdded + 1 <= upsellCount) {
					let upsell = availableUpsells[upsellsAdded];

					cards.push(upsell);
					upsellsAdded++;
				}
			});

			return cards;
		},
	},
	methods: {
		/**
		 * Determine if the card is a recommendation or an upsell.
		 *
		 * @param {{String}} type The card type.
		 *
		 * @returns {{boolean}} true if the card is a recommendation, false if it is an upsell.
		 */
		isRecommendation(type) {
			return 'recommendation' === type;
		},
	},
};
</script>
